export default {
  experimentId: '56',
  serverUrl: 'https://magpie-cogsciprag.fly.dev',
  socketUrl: 'wss://magpie-cogsciprag.fly.dev/socket',
  // this will be used in prolific mode
  completionUrl: 'https://app.prolific.com/submissions/complete?cc=CVZ2ZGX8',
  contactEmail: 'test@random.com',
  // Either 'debug', 'directLink' or 'prolific'
  mode: 'debug',
  language: 'en'
};
